<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="showLoadingSearch"
      variant="dark"
      opacity="0.61"
      :blur="'2px'"
      rounded="sm"
    >
      <b-form @submit="onSubmitFormClose">
        <b-form-row>
          <!-- <b-form-group class="col-12" label="Fecha inicio*">
            <b-form-datepicker
              :state="formValidate.startDate"
              v-model="formJSON.startDate"
              @input="validateForm()"
              placeholder="Fecha inicio"
            ></b-form-datepicker>
          </b-form-group> -->

          <b-form-group class="col-12" label="Fecha fin*">
            <b-form-datepicker
              :state="formValidate.endDate"
              v-model="formJSON.endDate"
              @input="validateForm()"
              placeholder="Fecha fin"
            ></b-form-datepicker>
          </b-form-group>

          <div class="col-12 d-flex flex-row align-items-end">
            <b-button
              type="submit"
              variant="primary"
              class="w-100 u:h-fit-content u:mb-2"
              >Procesar</b-button
            >
          </div>
        </b-form-row>
      </b-form>
    </b-overlay>
  </div>
</template>

<script>
// import Multiselect from "vue-multiselect";
import api from "@/api.js";
import moment from "moment";
export default {
  // components: { Multiselect },
  data() {
    return {
      showLoadingSearch: false,
      rate: 0,
      formJSON: {
        // startDate: "",
        endDate: "",
        action: "expire", //default expire or expireAndDuplicate
      },
      formValidate: {
        // startDate: false,
        endDate: false,
      },
    };
  },
  methods: {
    validateForm() {
      //validamos el campo #fecha de cierre
      //   if (this.formJSON.startDate.length <= 0) {
      //     this.formValidate.startDate = false;
      //     return;
      //   }
      //   this.formValidate.startDate = true;

      if (this.formJSON.endDate.length <= 0) {
        this.formValidate.endDate = false;
        return;
      }
      this.formValidate.endDate = true;
      return true;
    },
    setTypeOfClousure(status) {
      this.formJSON.action = status;
    },
    setRate(id) {
      this.rate = id;
      //recuperamos la fechas de la tarifa
      //validamos que sean distintas de null, si es el caso asignamos una fecha por default
      //   this.formJSON.startDate =
      //     this.rate.startDate != null
      //       ? this.rate.startDate
      //       : moment(new Date()).format("YYYY-MM-DD");
      this.formJSON.endDate =
        this.rate.endDate != null
          ? moment(this.rate.endDate).format('YYYY-MM-DD')
          : moment(new Date()).format("YYYY-MM-DD");
    },
    onSubmitFormClose(event) {
      event.preventDefault();
      //verificamos si el formulario se lleno correctamente
      if (!this.validateForm()) {
        this.$root.showAlert("Formulario incompleto", { variant: "danger" });
        return;
      }
      this.showLoadingSearch = true;
      //agregamos la hora a las 2 fechas
      //this.formJSON.endDate += " 23:59:59"; lo quite por que el back lo hace ahora
      //realizamos la peticion al endpoint
      api(this)
        .post("/rate-plans/" + this.rate.id + "/expire", this.formJSON)
        .then(() => {
          this.$emit("refreshTableRate");
          this.$emit("closeModal");
        })
        .catch(this.$root.handleRequestError)
        .finally(() => {
          this.showLoadingSearch = false;
        });
    },
  },
};
</script>

<style scoped>
hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
